(() => {
  const init = (root) => {
    root.querySelectorAll('.jw-popup').forEach((popup) => {
      if (popup.dataset.jenanFocusReady) return;
      popup.dataset.jenanFocusReady = 'true';
      let lastFocus = null;
      let wasOpen = false;
      const focusable = () => [...popup.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
      const sync = () => {
        const open = popup.classList.contains('popup-open');
        if (open && !wasOpen) {
          lastFocus = document.activeElement;
          popup.querySelector('.popup-close')?.focus({ preventScroll: true });
        } else if (!open && wasOpen && lastFocus?.isConnected) {
          lastFocus.focus({ preventScroll: true });
        }
        wasOpen = open;
      };
      new MutationObserver(sync).observe(popup, { attributes: true, attributeFilter: ['class'] });
      popup.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !popup.classList.contains('popup-open') || popup.getAttribute('aria-modal') !== 'true') return;
        const items = focusable();
        if (!items.length) { event.preventDefault(); popup.focus(); return; }
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === popup)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
